module.exports = __webpack_public_path__ + "static/img/pc_1.247fcd3.png";


//////////////////
// WEBPACK FOOTER
// ./static/fundingnew_/pc_1.png
// module id = fEgX
// module chunks = 1